import '.a{display:flex;}.ssr-plugin'
import '.ac{flex-direction:column;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.ah{gap:16px;}.ssr-plugin'
import '.f{width:100%;}.ssr-plugin'
import { FC } from 'react'
import { Layout } from './Layout'
import { styled } from 'inlines'
import { Navigation } from '../components/Navigation'
import { Canva } from '../components/Canva'
import { Text } from '../components/Text'
import { useTheme } from '../providers/useTheme'
import { CountdownTimer } from '../components/CountdownTimer'
import { useAppCtx } from '../providers/useAppCtx'
import { useContentQuery } from '../hooks/useContentQuery'
import {
  replaceMustachesInString,
  useMustacheIndex,
} from '../hooks/useTranslations'
import { Html } from '../components/Html'
import { useScrollToTop } from '../hooks/useScrollToTop'

export type CountdownProps = {
  countdown?: number
  'aria-label'?: {
    nav: string
    footer: string
  }
}

export const Countdown: FC<CountdownProps> = ({
  countdown,
  'aria-label': ariaLabelProp = {
    nav: 'Main navigation',
    footer: 'Footer navigation',
  },
}) => {
  const { languages } = useAppCtx()
  const { data: sequence = {} } = useContentQuery('sequence')
  const mustacheIndex = useMustacheIndex()
  const isVoting = sequence?.sequenceType === 'voting'
  const { colors } = useTheme()

  useScrollToTop()

  return (
    <Layout
      style={{
        padding: '32px 24px 96px',
        gap: 32,
      }}
    >
      <Layout.Navbar>
        <Navigation
          as="nav"
          aria-label={ariaLabelProp.nav}
          isCartVisible={isVoting}
          isExpandable
          languages={languages}
        />
      </Layout.Navbar>

      {sequence?.media && (
        <Layout.Top
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            flex: 1,
            maxWidth: 480,
            maxHeight: 296,
          }}
        >
          <Canva
            src={sequence?.media?.src}
            size={{
              width: 180,
              height: 180,
            }}
          />
        </Layout.Top>
      )}

      <Layout.Middle>
        <div className="a ac c d ah f"
        >
          {sequence?.prompt && (
            <Text
              color={colors.textSecondary}
              variant="subheading-regular"
              isMultiline
            >
              {replaceMustachesInString(sequence?.prompt, mustacheIndex)}
            </Text>
          )}

          {typeof countdown === 'number' && (
            <CountdownTimer targetTimestamp={countdown} />
          )}

          {sequence?.details && (
            <Html color={colors.textSecondary} variant="subheading-regular">
              {replaceMustachesInString(sequence?.details, mustacheIndex)}
            </Html>
          )}
        </div>
      </Layout.Middle>

      <Layout.Footer>
        <Navigation
          as="footer"
          aria-label={ariaLabelProp.footer}
          languages={languages}
        />
      </Layout.Footer>
    </Layout>
  )
}
